import { get } from 'lodash';
import { type IHydrateWidgetInput } from '../../../../../../hydrate/IHydrationContext.ts';
import { type IBaseWidget } from '../../../../IBaseWidget.ts';
import { getAsyncServiceLabel } from '../components/label/getSelectedValueLabel.ts';
import { asyncSelectWidgetObjectName } from '../hooks/asyncSelectObjectName.ts';
import { type IAsyncSelectWidget } from '../IAsyncSelectWidget.ts';

/**
 * Funzione per l'estrazione dell'idratazione centralizzata per i widget async (AsyncSelect e AsyncValue).
 */
export function hydrateAsyncWidget<
  W extends IBaseWidget &
    Pick<IAsyncSelectWidget, 'labelFields' | 'labelField'>,
>(input: IHydrateWidgetInput<W>) {
  const { context, path, widget } = input;
  try {
    // Recupero la chiave <path>@object
    const objectKey = asyncSelectWidgetObjectName(path);
    const values = get(context.values, objectKey);
    // Recupero il valore utilizzato come label
    const labelValue = getAsyncServiceLabel(widget.labelFields, values);

    // Lo ritorno, il campo andrà a sovrascrivere il valore ritornato.
    return {
      value: labelValue,
    };
  } catch (error) {
    // biome-ignore format: <tbd>
    console.error(`[Async Widget] Errore durante l'hydrate del widget ${path} (type: ${widget.type})`, { context, path, widget, error });
    return {
      value: 'N/A',
    };
  }
}
